module.exports = __webpack_public_path__ + "img/1.0f05d9ed.jpg";